import { gql } from '@/__generated__';

export const GET_USER_PREFERRED_UNITS = gql(`#graphql
  query GetUserPreferredUnits($input: UserInput) {
    user(input: $input) {
      id
      preferences {
        id
        preferredUnits {
          id
          configurations {
            name
            deviceType
            unit
            precision
          }
          defaultValues: configurations(defaultValues: true) {
            name
            deviceType
            unit
            precision
          }
        }
      }
    }
  }
`);
